import React, { useState, useEffect, useRef } from 'react';

// Self-contained search input: owns its own text state and debounces before
// notifying the parent, so parent re-renders and loading states never reset,
// remount, or steal focus from the input while the user is typing.
const SearchBar = ({ placeholder = 'Search...', onSearch, delay = 500, className = 'search-input' }) => {
  const [value, setValue] = useState('');
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;
  const isFirstRender = useRef(true);

  useEffect(() => {
    // The parent already fetches with an empty search on mount.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timer = setTimeout(() => onSearchRef.current(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return (
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      className={className}
    />
  );
};

export default React.memo(SearchBar);
